import { Component, inject } from '@angular/core';
import {MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import { ButtonSize, ButtonState, ButtonType, InputSize, InputState } from '../../../assets/types/dtoTypes';
import {AppInputAreaComponent} from "../../shared/text-areas/app-input-area.component";
import {TranslateModule} from "@ngx-translate/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {ButtonComponent} from "../../shared/button/button.component";
import {FormsModule} from "@angular/forms";
import {MatLabel} from "@angular/material/input";

@Component({
  selector: 'app-job-apply-modal',
  templateUrl: './job-apply-modal.component.html',
  standalone: true,
  imports: [
    AppInputAreaComponent,
    MatDialogContent,
    TranslateModule,
    MatCheckbox,
    ButtonComponent,
    FormsModule,
    MatLabel,
    MatDialogTitle
  ],
  styleUrl: './job-apply-modal.component.scss'
})
export class JobApplyModalComponent {
  private dialogRef = inject<MatDialogRef<JobApplyModalComponent>>(MatDialogRef);

  isLoading = false;

  message = '';

  includeCV = true;

  constructor() {}

  submit(): void {
    this.dialogRef.close( { message: this.message, includeCV: this.includeCV } );
  }

  close() {
    this.dialogRef.close();
  }

  onMessageChange( event: string ) {
    this.message = event;
  }

  protected readonly InputSize = InputSize;

  protected readonly InputState = InputState;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonType = ButtonType;

  protected readonly ButtonState = ButtonState;
}
